import { render, staticRenderFns } from "./SimilarityMap.vue?vue&type=template&id=6b003ab6&scoped=true"
import script from "./SimilarityMap.vue?vue&type=script&lang=js"
export * from "./SimilarityMap.vue?vue&type=script&lang=js"
import style0 from "./SimilarityMap.vue?vue&type=style&index=0&id=6b003ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b003ab6",
  null
  
)

export default component.exports